/**
 * Created by Ning Jiang on 2/7/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {StepCountUpBigWinController} from "@nolimitcity/slot-game/bin/game/winpresentation/bigwin/stepcountup/StepCountUpBigWinController";
import {Timeline} from "gsap";
import {BarbarianFuryGameConfig} from "../../BarbarianFuryGameConfig";
import {BarbarianFuryBigWinCountUp} from "./BarbarianFuryBigWinCountUp";
import {BarbarianFuryBigWinView} from "./BarbarianFuryBigWinView";

export class BarbarianFuryBigWinController extends StepCountUpBigWinController {

    private _gameView:BarbarianFuryBigWinView;
    private _winCountUp:BarbarianFuryBigWinCountUp;

    constructor(indexes:[number, number]) {
        super(indexes, {skipLastLevelCountUpIfSmall : false});

        this._gameView = new BarbarianFuryBigWinView();
        this._winCountUp = new BarbarianFuryBigWinCountUp();
        this._winCountUp.position.set(GameConfig.instance.GAME_WIDTH * 0.5, GameConfig.instance.GAME_HEIGHT * 0.5);
        StageManager.getLayer(BarbarianFuryGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this._winCountUp);
    }

    protected getBigWinLevelAnimation(level:number):Timeline {
        return this._gameView.getBigWinLevelAnimation(this._winRatios[level], level);
    }

    protected playCountUp(from:number, to:number, duration:number, preTotalWin:number = 0):Timeline | null {
        return this._winCountUp.getCountUpAnimation(from, to, duration);
    }

    protected playEndingAnimation(isAborted:boolean):void {
        this._gameView.playEndingAnimation(this._winRatios[this._winLevel]);
        SlotGame.winFieldController.showWinField();
        this._winCountUp.abort(this._gameData!.singleWin, isAborted);
        //  added check to send aborted true if there is respin, and bigwin is aborted => nudge before respin start
        if(this._gameData!.nextMode.indexOf("RESPIN") !== -1 && isAborted) {
            EventHandler.dispatchEvent(new GameEvent("SET_ABORTED_TRUE"));
        }
    }
}